module.exports = __webpack_public_path__ + "img/img2.6974d876.jpg";